<script>
    import{user_data} from './stores.js';
    import { onMount } from "svelte";
    import Iqtemplate from "./components/iqtemplate.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';
    import {link, location, push, pop, replace} from 'svelte-spa-router';


    onMount(async() => {

    });

</script>

<Iqtemplate>
    <div class="cszinputcontainer">
        <div class="cszinputfieldcontainer">
            <div class="progresstext">5/6</div>
            <div class="csztopcopy">
                Do you currently own a home?
            </div>
            <Chipscompnent
            chipsdata={ [
                {sz: "med", s: false, t: "Yes", i:"/img/Check.svg", cbf:()=>{$user_data.current_home_owner = true;}, n: "#/current_home_type"},
                 {sz: "med", s: true, t: "No", i:"/img/X.svg", cbf:()=>{$user_data.current_home_owner = false;}, n: "#/qualify"},
            ] }
            />

            <div class="progressbuttonholder">
                <button on:click={()=>{push("#/");}} class="backbutton"><span class="backarrowcontainer"><img src="/img/triangle-left-arrow.svg" alt="back arrow" /></span>Go Back</button>
            </div>

        </div>
    </div>

</Iqtemplate>

<style>

</style>